import { render } from "./tokitchen.vue?vue&type=template&id=d27105ca"
import script from "./tokitchen.vue?vue&type=script&lang=js"
export * from "./tokitchen.vue?vue&type=script&lang=js"

import "./tokitchen.vue?vue&type=style&index=0&id=d27105ca&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__